import { useCookieConsent } from '../hooks/useCookieConsent';

function CookieIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      <path d="M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5" />
      <path d="M8.5 8.5v.01" />
      <path d="M16 15.5v.01" />
      <path d="M12 12v.01" />
      <path d="M11 17v.01" />
      <path d="M7 14v.01" />
    </svg>
  );
}

/**
 * Entry point persistente per riaprire le preferenze e revocare il consenso
 * (la revoca dev'essere facile come il conferimento — art. 7 GDPR).
 * Visibile solo dopo la prima scelta; bottom-left per non collidere con la
 * CallOverlay (bottom-right).
 */
export function CookieSettingsButton() {
  const { hasDecided, openPreferences } = useCookieConsent();
  if (!hasDecided) return null;

  return (
    <button
      type="button"
      onClick={openPreferences}
      aria-label="Preferenze cookie"
      title="Preferenze cookie"
      className="fixed bottom-4 left-4 z-40 flex h-11 w-11 items-center justify-center rounded-full border border-neutral-200 bg-white text-brand-navy shadow-md transition-colors hover:bg-brand-teal-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-teal"
    >
      <CookieIcon className="h-5 w-5" />
    </button>
  );
}
